import React, { useState, useEffect } from 'react';
import './AmazonProfileSelect.css';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, PRIMARY } from '../../../appConstants';
import { CircularProgress } from '@mui/joy';

function App() {
    const navigate = useNavigate();
    const platform_id = "2b2c5687-6887-4f4c-9509-4abd7341b81e";
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [redirectloading, setRedirectLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [brandId, setBrandId] = useState(null);
    const [id, setId] = useState(null);

    useEffect(() => {
      // Get brand_id from URL query parameters
      const urlParams = new URLSearchParams(window.location.search);
      const brand_Id = urlParams.get('brand_id');
      const id = urlParams.get('id');
      
      if (!brand_Id) {
        setError('Brand ID is required in URL parameters');
        setLoading(false);

        return;
      }

      if (!id) {
        setError('ID is required in URL parameters');
        setLoading(false);

        return;
      }

      setBrandId(brand_Id);
      setId(id);
      fetchProfiles(brand_Id, id);
    }, []);
  
    console.log('-->', brandId, platform_id, id)
    const fetchProfiles = async (ag_brandId, ag_id) => {
      const token = localStorage.getItem("token");
      if(!token){
        setLoading(false);
        // navigate(`/login/${brandId}`);
        // return;
        const timer = setTimeout(() => {
              navigate(`/login/${ag_brandId}/${ag_id}`);
          }, 3000); // 5000 milliseconds = 5 seconds

          // Cleanup function to prevent memory leaks
          return () => clearTimeout(timer); 
      }

      setRedirectLoading(false);
      try {

        setLoading(true);
        setError(null);
        // brand_id=${brandId}&platform_id=${platform_id}
        // https://secure.infytrix.live:3011/
        const response = await fetch(`${BASE_URL}apiAccess/amazonAdsProfileIds?brand_id=${ag_brandId}&platform_id=${platform_id}&id=${ag_id}`,
          {
            method: "GET", // or "POST" if required
            headers: {
              "Authorization": `Bearer ${token}`,  // 🔑 pass token here
              "Content-Type": "application/json"
            }
          }
        );
        const result = await response.json();
        
        if (result.status === 'success') {
          setProfiles(result.data.profileIds);
        } else {
          setError(result.data?.error || 'Failed to fetch profiles');
        }
      } catch (err) {
        setError('Network error: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
  
    const handleProfileSelect = (profile) => {
      setSelectedProfile(profile);
    };
  
    const handleSubmit = async (brandId, ag_id) => {
      const token = localStorage.getItem("token");
      if(!token){
        setLoading(false);
        // navigate(`/login/${brandId}`);
        // return;
        const timer = setTimeout(() => {
              navigate(`/login/${brandId}/${ag_id}`);
          }, 3000); // 5000 milliseconds = 5 seconds

          // Cleanup function to prevent memory leaks
          return () => clearTimeout(timer); 
      }

      if (!selectedProfile) {
        setSubmitMessage('Please select a profile first');
        setShowMessage(true);
        return;
      }
  
      try {
        setSubmitting(true);
        setSubmitMessage('');
        setShowMessage(false);
        const response = await fetch(`${BASE_URL}apiAccess/amazonAdsProfileId?brand_id=${brandId}&platform_id=${platform_id}&id=${ag_id}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${token}`,  // 🔑 pass token here
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            profile_object: selectedProfile
          })
        });
        
        const result = await response.json();
        
        if (result.status === 'success') {
          setSubmitMessage('Profile submitted successfully!');
          setShowMessage(true);
        } else {
          setSubmitMessage('Failed to submit profile: ' + (result.data?.message || 'Unknown error'));
          setShowMessage(true);
        }
      } catch (err) {
        setSubmitMessage('Network error: ' + err.message);
        setShowMessage(true);
      } finally {
        setSubmitting(false);
      }
    };
  
    const closeMessage = () => {
      setShowMessage(false);
      setSubmitMessage('');
    };
  
    if (loading) {
      return (
        <div className="App">
          <div className="loader-container">
            <div className="loader"></div>
            <p>Loading profiles...</p>
          </div>
        </div>
      );
    }

    if (redirectloading) {
      return (
        <div className="w-full h-[100vh] flex justify-center items-center">
            <CircularProgress />
        </div>
      );
    }
  
    if (error) {
      return (
        <div className="App">
          <div className="error-container">
            <h2>Error</h2>
            <p>{error}</p>
          </div>
        </div>
      );
    }
  
    return (
      <div className="App">
        <header className="App-header text-center">
          <h1>Amazon Ads Profile Selection</h1>
          <p>Select a profile to continue</p>
        </header>
        
        <main className="App-main">
          <div className="profiles-grid">
            {profiles.map((profile, index) => (
              <div 
                key={profile.profileId} 
                className={`profile-tile ${selectedProfile?.profileId === profile.profileId ? 'selected' : ''}`}
              >
                <div className="profile-header">
                  <input
                    type="radio"
                    name="profile"
                    id={`profile-${profile.profileId}`}
                    checked={selectedProfile?.profileId === profile.profileId}
                    onChange={() => handleProfileSelect(profile)}
                  />
                  <label htmlFor={`entityId-${profile.accountInfo.id}`}>
                    <strong>Entity ID: {profile.accountInfo.id}</strong>
                  </label>
                </div>
                
                <div className="profile-details">
                  <div className="detail-row">
                    <span className="label">Account Name:</span>
                    <span className="value">{profile.accountInfo.name}</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Profile Id:</span>
                    <span className="value">{profile.profileId}</span>
                  </div>
                  <div className="detail-row">
                    <span className="label">Account Type:</span>
                    <span className="value">{profile.accountInfo.type}</span>
                  </div>
    
                </div>
              </div>
            ))}
          </div>
          
          <div className="submit-section">
            <button 
              className="submit-button" style={{
                backgroundColor: PRIMARY.P_BLue,
              }}
              onClick={() => handleSubmit(brandId, id)}
              disabled={!selectedProfile || submitting}
            >
              {submitting ? (
                <>
                  <div className="button-loader"></div>
                  Submitting...
                </>
              ) : (
                'Submit Selected Profile'
              )}
            </button>
          </div>
        </main>
  
        {/* Message Modal */}
        {showMessage && (
          <div className="message-overlay">
            <div className={`message-container ${submitMessage.includes('successfully') ? 'success' : 'error'}`}>
              <div className="message-header">
                <h2>{submitMessage.includes('successfully') ? 'Success' : 'Error'}</h2>
                <button className="close-button" onClick={closeMessage}>×</button>
              </div>
              <div className="message-content">
                <p>{submitMessage}</p>
              </div>
              <div className="message-footer">
                <button className="ok-button" onClick={closeMessage}>
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
  
  export default App;
  